import BaseComponent from '../base.js';
import tag from '../utilComponents.js';
import Key from '../key/key.js';

import KEYS_BY_DIFFICULTY from '../../keys.json';

import * as styles from './keyset.module.scss';

const letters = KEYS_BY_DIFFICULTY.medium;

const digits = KEYS_BY_DIFFICULTY.easy;

export default class Keyset extends BaseComponent {
  /**
   * @type {KeysetType}
   * @private
   */
  type;

  /** @param {KeysetType} keyboardType */
  constructor(keyboardType) {
    super({ classes: [styles.keyset] });

    this.type = keyboardType;

    this.fillKeyboard();

    window.addEventListener(
      'changedifficulty',
      this.handleKeyboardDisplay.bind(this)
    );
  }

  /**
   * Adds buttons to keyboard component depending on keyboard type.
   * @returns {void}
   * @private
   */
  fillKeyboard() {
    if (this.type === 'letters') this.addLetters();
    if (this.type === 'digits') this.addDigits();
  }

  /**
   * Fills the keyboard component with letter keys.
   * @returns {void}
   * @private
   */
  addLetters() {
    if (this.state.difficulty === 'easy') {
      this.addClasses(styles.keysetInactive);
    }

    let keyRow = tag.div({ classes: [styles.keysetKeyRow] });

    letters.forEach((char, i) => {
      const key = new Key({ text: char }, char);
      this.passCallbackToState(key, char);
      keyRow.appendSingle(key);

      const isKeyRowFull = char === 'P' || char === 'L';
      const isLastChar = i === letters.length - 1;

      if (isKeyRowFull || isLastChar) {
        this.appendSingle(keyRow);
        keyRow = tag.div({ classes: [styles.keysetKeyRow] });
      }
    });
  }

  /**
   * Fills the keyboard component with digit keys.
   * @returns {void}
   * @private
   */
  addDigits() {
    if (this.state.difficulty === 'medium') {
      this.addClasses(styles.keysetInactive);
    }

    const keyRow = tag.div({ classes: [styles.keysetKeyRow] });

    digits.forEach((digit) => {
      const key = new Key({ text: digit }, digit);
      this.passCallbackToState(key, digit);
      keyRow.appendSingle(key);
    });

    this.appendSingle(keyRow);
  }

  /**
   * Displays or hides keyboard component depending on difficulty level.
   * @param {CustomEvent<Partial<StateObj>>} e
   * @returns {void}
   * @private
   */
  handleKeyboardDisplay(e) {
    const { difficulty } = e.detail;

    if (this.type === 'letters') {
      if (difficulty === 'easy') this.addClasses(styles.keysetInactive);
      if (difficulty === 'medium') this.removeClasses(styles.keysetInactive);
    }

    if (this.type === 'digits') {
      if (difficulty === 'easy') this.removeClasses(styles.keysetInactive);
      if (difficulty === 'medium') this.addClasses(styles.keysetInactive);
    }

    if (difficulty === 'hard') this.removeClasses(styles.keysetInactive);
  }

  /**
   * Fills the state's keycallback property with keyboard keys and their callbacks.
   * @param {Key} keyComponent
   * @param {string} key
   * @returns {any}
   * @private
   */
  passCallbackToState(keyComponent, key) {
    const callback = keyComponent.activate.bind(keyComponent);
    this.state.keycallbacks[key] = callback;
  }
}
